import { OtherDevices } from "./OtherDevices";
import { AddNew } from "./AddNew";
import { InventoryForm } from "./FORMS/InventoryForm";
import { NewInventoryForm } from "./FORMS/NewInventoryForm";
import { UserForm } from "./FORMS/UserForm";
import { NewUserForm } from "./FORMS/NewUserForm";
import { Search } from "../Search";
import { ExportView } from "./ExportView";
import { CityDetails } from "./CityDetails";
import { ChartController } from "./ChartController";

export class ModalController {

    constructor(store) {
        this.store = store;
        this.modal = null;
        this.details = null;
        this.modalComponent = null;
        this.detailsComponent = null;
        this.MODAL_LAYOUTS = {
            MODALCLOSE: {
                modalState: "close",
            },
            MODALOPEN: {
                modalState: "open",
                modalSize: "narrow",
                details: "close",
                modalContent: "wide",
                avatarCircle: "large",
                radius: 210,
                avatarScale: 0.32
            },
            MODALAUTH: {
                modalState: "open",
                modalSize: "auth",
                details: "close",
            },
            MODALOPENWITHDETAILS: {
                modalState: "open",
                modalSize: "wide",
                details: "open",
                modalContent: "narrow",
                avatarCircle: "small",
                radius: 160,
                avatarScale: 0.36
            }
        };
        this.currentLayout = this.MODAL_LAYOUTS.MODALCLOSE;
        this.currentComponent = "DEVICES";
        this.currentData = null;
        this.cityDetails = new CityDetails(this.store)
        this.createModal();

    }

    async setLayout({ layout, component, data }) {
        //console.log(layout, component, data)
        const changed = this.currentLayout !== this.MODAL_LAYOUTS[layout];
        this.currentLayout = this.MODAL_LAYOUTS[layout];
        this.currentComponent = component;
        this.currentData = data;
        if (changed) {
            this.updateLayout();
            this.modal.addEventListener("transitionend", () => this.store.deviceAvatar.layout(), { once: true });
        }
        if(component !== null){this.renderLayout();}
        
    }

    async updateLayout() {
        this.modal.className = `modal modal-${this.currentLayout.modalState} modal-${this.currentLayout.modalSize}`;
        if (this.currentLayout.modalContent) {this.modalContent.id = `modalcontent-${this.currentLayout.modalContent}`;}
        if (this.currentLayout.details) {this.details.id = `modaldetails-${this.currentLayout.details}`;}
    }

    async renderLayout() {
        //console.log('renderLayout ', this.currentComponent)
        switch (this.currentComponent) {
            case "DEVICES": return this.showDevices();
            case "OFFICES": return this.showOffices();
            case "__CITIES__": return this.showCityUsers();
            case "__OTHER_DEVICES__": return this.showOtherDevices();
            case "CITYDETAILS": return this.showCityDetails(this.currentData);
            case "__PLUS__": return this.showAddNew();
            case "Új kolléga": return this.showNewUserForm();
            case "Új bútor":
            case "Új eszköz": return this.showNewInventoryForm();
            case "__SET__": return this.showUserForm();
            case "SEARCH": return this.showSearch();
            case "SHOWEXPORT": return this.showExport();
            case "NAKBUDAPEST": return this.showBudapest();
            case "AUTH": return this.showAuth(this.currentData);
            case "CHART": return this.showChart();
            default: return this.showInventoryForm(this.currentData);
        }
    }

    async showDevices() {
        this.store.datas.getUserDevices(this.store.level.selectedColleague.id)
        .then(data => {
            this.store.database.actualDevices = data;
            const wrapper = this.store.devices.render();
            this.showModal(wrapper, "DEVICES");
            requestAnimationFrame(() => {this.store.deviceAvatar.layout();});
        }).catch(error => { console.log('FIRESTOREERROR', error) })
    }
    
    async showModal(content, view, onClose = null) {
        this.store.level.detailsVisible = false;
        this.modalComponent = view;
        this.onClose = onClose;
        this.modalContent.innerHTML = "";
        this.modalContent.appendChild(content);
        this.store.level.modalOpen = true;
    }

    async showDetails(component) {
        //AZ INVENTORYFORM PÉLDÁNYOK TÖRLÉSE
        if (this.detailsComponent?.destroy) {this.detailsComponent.destroy();}
        if(component === null){return}
        this.detailsComponent = component;
        this.details.innerHTML = "";
        const node = await component.render();
        this.details.appendChild(node);
        this.store.level.detailsVisible = true;
    }

    async showComponent(component, view, onClose = null) {
        this.modalComponent = view;
        this.onClose = onClose;
        this.modalContent.innerHTML = "";
        this.modalContent.appendChild(component.render());
        this.store.level.modalOpen = true;
    }

    async showUserForm() {this.showDetails(new UserForm(this.store));}

    async showInventoryForm(device) {
        this.store.level.selectedDevice = device;
        this.store.level.formMode = "MODIFY";
        this.showDetails(new InventoryForm(this.store));
    }

    async showNewInventoryForm() {
        this.store.level.selectedDevice = null;
        const newInventoryForm = new NewInventoryForm(this.store)
        const wrapper = await newInventoryForm.render(this.currentComponent);
        this.showModal(wrapper, "NEWINVENTORYFORM");
    }

    async showCityUsers() {
        this.store.level.cityCaller = 'USER'
        let allCitiesInDistrict = await this.store.datas.filter('CITIES', 'district', this.store.level.selectedDistrict);
        this.store.database.actualLocations = await this.store.datas.getCitiesByUserid(this.store.level.selectedColleague.id)
        this.store.database.possiblyLocations = allCitiesInDistrict.filter(city =>!this.store.database.actualLocations.some(existing => existing.id === city.id));
        this.store.levelController.setLevel({name: "CITIES", office: this.store.level.selectedOffice, position: null});
    }

    async showOffices() {
        this.store.level.cityCaller = 'OFFICE'
        this.store.database.actualLocations = await this.store.datas.filter('CITIES', 'district', this.store.level.selectedOffice);
        this.store.levelController.setLevel({name: "CITIES", office: this.store.level.selectedOffice, position: null});
    }

    async showOtherDevices() {this.showDetails(new OtherDevices(this.store));}

    async showCityDetails() {
        let wrapper = null;
        if(this.store.level.selectedCity.label !== 'Budapest' || this.store.level.selectedCity.label !== 'Selejt' || this.store.level.selectedCity.label !== 'Tesztiroda' || this.store.level.selectedCity.label !== 'Tesztiroda2'){
            wrapper = await this.cityDetails.render(this.store.level.selectedCity.officeid);
        }else{
            wrapper = await this.cityDetails.render(this.store.level.selectedCity.id);
        }
        this.showModal(wrapper, 'BUDAPEST');
    }

    async showAuth(data = null) {
        let wrapper;
        if (data?.type === "LOGIN") {
            wrapper = await this.store.authentication.renderLogin(data);
            this.showModal(wrapper, "AUTH");
            await this.store.authentication.loginUser(data.poolUser);
            return;
        }
        wrapper = await this.store.authentication.render();
        this.showModal(wrapper, "AUTH");
    }

    async showAddNew() {
        if(this.currentData.barcode === undefined){
            const addNew = new AddNew(this.store);
            const wrapper = addNew.render(this.currentData.constructor.name);
            this.showModal(wrapper, "ADDNEW");      
        }else {
            this.callNewForm("Új eszköz");
            return;
        }
        
      
    }

    async showExport() {
        const exportView = new ExportView(this.store);
        const wrapper = exportView.render();
        this.showModal(wrapper, "SHOWEXPORT");
    }
/*
    async showNewForm() {
        const newForm = new NewForm(this.store)
        const wrapper = await newForm.render(this.currentComponent);
        this.showModal(wrapper, "NEWFORM");
    }
*/
    async showNewUserForm() {
        const newUserForm = new NewUserForm(this.store)
        const wrapper = await newUserForm.render(this.currentComponent);
        this.showModal(wrapper, "NEWUSERFORM");
    }

    async showSearch() {
        const search = new Search(this.store)
        const wrapper = await search.render(this.currentComponent);
        this.showModal(wrapper, "SEARCH");
    }

     async showChart() {
        const chartController = new ChartController(this.store)
        const wrapper = chartController.render(this.currentComponent);
        this.showModal(wrapper, "CHART");
    }

    async showBudapest() {
        const wrapper = await this.listRenderer.render(27);
        this.showModal(wrapper, 'BUDAPEST');
    }


    async callNewForm(item) {
        if(item === 'Új eszköz'){
            this.store.datas.load('CITIES')
            .then(data => {
                this.store.datas.load('INVENTORY')
                .then(data => {this.store.modalController.setLayout({layout: "MODALOPEN", component: "Új eszköz", data: null});}
                )
                .catch(error => { console.log(error) })
            }).catch(error => { console.log(error) })
        }else{
            if(item.id === 'Új bútor'){
                this.store.datas.load('INVENTORY')
                .then(data => {this.store.modalController.setLayout({layout: "MODALOPEN", component: "Új bútor", data: null});})
                .catch(error => { console.log(error) })
            }else if(item.id === 'Új kolléga') {
                this.store.datas.load('CITIES')
                .then(data => {this.store.modalController.setLayout({layout: "MODALOPEN", component: "Új kolléga", data: null});})
                .catch(error => { console.log(error) })
            }
        }
    }

    createModal() {
        // ---------------- MODAL ----------------
        this.modal = document.createElement("div");
        this.modal.className = 'modal-close';
        document.body.appendChild(this.modal);
        // ---------------- LAYOUT ----------------
        this.layout = document.createElement("div");
        this.layout.id = "modallayout";
        // ---------------- MODAL CONTENT ----------------
        this.modalContent = document.createElement("div");
        this.modalContent.id = "modalcontent-wide";
        // ---------------- DETAILS ----------------
        this.details = document.createElement("div");
        this.details.id = "modaldetails-close";
            // ---------------- APPEND ----------------
        this.layout.appendChild(this.modalContent);
        this.layout.appendChild(this.details);
        this.modal.appendChild(this.layout);
        // ---------------- LISTENER ----------------
        this.modal.addEventListener("transitionend", this.onTransitionEnd.bind(this));
    }

    onTransitionEnd(e) {
        if (e.propertyName !== "left") return;
        if (this.currentLayout.modalState !== "close") return;
        this.closeModal();
    }

    closeModal() {
        this.modalContent.innerHTML = "";
        this.details.innerHTML = "";
        this.store.level.detailsVisible = false;
        //this.store.level.selectedColleague = null;
        //this.store.level.selectedOffice = null;
        this.store.level.itDevices = [];
        this.store.level.otherDevices = [];
        this.store.level.modal = null;
        this.store.level.modalOpen = false;
        this.store.level.detailsVisible = false;
        this.onClose?.();
        this.onClose = null;
        this.onDetailsClose?.();
    }

      
}